import React, { useRef } from "react";
import { FormGroup, FormControl, ControlLabel, Checkbox, Button, Glyphicon } from "react-bootstrap";
import locale from "../../../../../locale";
import FormControlLanguage from "../../../../UI/FormControlLanguage";
import CPSettingSize from "../../../../UI/Settings/CPSettingSize";

export default ({ block, blockProperties, onUpdateBlockProperties, onSave, onSaveFile }) => {
    const imageInputRef = useRef(null);

    return (
        <div>
            <FormGroup>
                <ControlLabel>{locale('settings.title')}</ControlLabel>
                <FormControlLanguage
                    type="text"
                    placeholder={locale('settings.placeholder.title')}
                    values={{
                        ru: blockProperties?.titleRu || '',
                        en: blockProperties?.titleEn || '',
                    }}
                    onChange={{
                        ru: (e) => onUpdateBlockProperties({ titleRu: e.target.value }),
                        en: (e) => onUpdateBlockProperties({ titleEn: e.target.value }),
                    }}
                    onBlur={() => onSave({
                        titleRu: blockProperties.titleRu,
                        titleEn: blockProperties.titleEn,
                    })}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>{block.imageUrl ? "Изменить" : "Добавить"} изображение</ControlLabel>
                {block.imageUrl && <div><img src={block.imageUrl} style={{ maxWidth: '100%', maxHeight: 120 }} alt="" /></div>}
                <div>
                    <Button onClick={() => imageInputRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
                    {block.imageUrl && <Button onClick={() => onSaveFile('image', 'DELETE')} bsStyle="danger"><Glyphicon glyph="trash" /></Button>}
                </div>
                <FormControl
                    type="file"
                    onChange={(e) => onSaveFile('image', e.target.files[0] || null)}
                    inputRef={ref => imageInputRef.current = ref}
                    style={{ display: 'none' }}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>{locale('settings.subtitle')}</ControlLabel>
                <Checkbox
                    style={{ marginTop: 0 }}
                    checked={blockProperties?.descriptionSettings?.enabled}
                    onChange={(e) => onSave({ descriptionSettings: { ...blockProperties?.descriptionSettings, enabled: e.target.checked } })}
                >
                    {locale('settings.showSubtitle')}
                </Checkbox>
            </FormGroup>
            {blockProperties?.descriptionSettings?.enabled &&
                <DescriptionSettings
                    description={blockProperties?.descriptionSettings || {}}
                    onChange={(descriptionSettings) => onUpdateBlockProperties({ descriptionSettings })}
                    onSave={(descriptionSettings) => onSave({ descriptionSettings })}
                />}
            <ControlLabel>Выделять топ рейтинга</ControlLabel>
            <Checkbox
                style={{ marginTop: 0 }}
                checked={blockProperties?.topRatedSeparateDisplay}
                onChange={(e) => onSave({ topRatedSeparateDisplay: e.target.checked })}
            >
                Выделять
            </Checkbox>
        </div>
    )
};

const DescriptionSettings = ({ description, onChange, onSave }) => {
    return <div>
        <FormGroup>
            <FormControlLanguage
                type="textarea"
                rows={4}
                placeholder={locale('settings.placeholder.subtitle')}
                values={{
                    ru: description.textRu || '',
                    en: description.textEn || '',
                }}
                onChange={{
                    ru: (e) => onChange({ ...description, textRu: e.target.value }),
                    en: (e) => onChange({ ...description, textEn: e.target.value }),
                }}
                onBlur={() => onSave({ ...description, textRu: description.textRu, textEn: description.textEn })}
            />
        </FormGroup>
        <div style={{ display: 'flex', gap: "1rem", marginTop: '2rem', alignItems: 'flex-start' }}>
            <CPSettingSize
                name="textSize"
                label={locale('settings.textSize')}
                eventValue={description.textSize}
                defaultValue={'16px'}
                onChange={(value) => onSave({ ...description, ...value })}
            />
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                <FormControl
                    type="color"
                    value={'#' + description.textColor}
                    onChange={({ target }) => onChange({ ...description, textColor: target.value.replace('#', '') })}
                    onBlur={() => onSave({ ...description, textColor: description.textColor })}
                />
                <ControlLabel>Цвет текста</ControlLabel>
            </div>
        </div>
    </div>
}
